// NPM Imports
import React from "react";
import { Redirect, Route } from "react-router-dom";

// Components Import
import { AuthenticateUser } from "../components";

// Methods Imports
import {
  isUserAuthenticated,
  getValidSubDomainUrl,
  getValidFullSubDomainUrl,
  getRedirectUrlPostSignout,
} from "../actions/AuthActions/authMethods";

// Internals Imports
import { GlobalUtils } from "../utils";
import { injectDriftChat } from "./methods";
import { NAVBAR, SETTINGS, AUTH } from "../constants";

// Destructuring
const { LOCAL } = AUTH;
const { NAVITEMS } = NAVBAR;
const { SETTINGS_VIEWS } = SETTINGS;
const {
  readDataFromLocalStorage,
  readCookie,
  removeCookie,
  setCookie,
} = GlobalUtils;

const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={props => {
      // if user is logged in
      if (isUserAuthenticated()) {
        const userPermissions = readDataFromLocalStorage(
          "revvsalesUserPermissions",
        );
        // Add 3rd party library code(s) inside the app

        let viewsArray;
        let defaultView;
        let pathProp;
        // if user trying to goto settings pages
        if (rest.location && rest.location.pathname.includes("settings")) {
          viewsArray = SETTINGS_VIEWS;
          defaultView = "/settings/profile";
          pathProp = "fullpath";
        }
        // if user not trying to goto settings pages
        else {
          viewsArray = NAVITEMS.salesOps.navItems;
          defaultView = `/${AUTH.DEFAULT_AUTH_REDIRECTION_URL}`;
          pathProp = "link";
        }

        const matchView = viewsArray.find(view => {
          if (
            rest.location &&
            rest.location.pathname.includes(view[pathProp])
          ) {
            return view;
          }
          return null;
        });

        // if selected view has a readPermission attached to it
        if (
          matchView &&
          Object.prototype.hasOwnProperty.call(matchView, "readPermission")
        ) {
          if (
            userPermissions &&
            userPermissions.find(
              permission => permission.name === matchView.readPermission,
            )
          ) {
            // user has the attached permission
            return injectDriftChat(Component, props);
          }
          // user doesn't have the attached permission
          return <Redirect to={defaultView} />;
        }
        // no permisision attached to view
        return injectDriftChat(Component, props);
      }

      /**
       * If user is not logged in,
       * 1. read the 'user' data from the cookie
       * 2. if 'user' data & 'subdomain' are present then, authenticate user with that data
       *     else, redirect to the auth url (ex: signin or signup auth)
       */
      const userData = readCookie("user");
      const subDomain = userData ? JSON.parse(userData).subdomain : "";
      if (userData && subDomain) {
        const userObj = JSON.parse(userData);
        const validUrl = getValidSubDomainUrl(subDomain);
        const currentUrl = window.location.origin;
        const envName = process.env.REACT_APP_ENVIRONMENT;
        const checkAuth = readCookie("checkAuth");

        /**
         * 1. Check if env is 'LOCAL' or
         * if current url is same as the user's valid url then,
         * do the normal authentication flow
         */
        if (envName === LOCAL || currentUrl === validUrl) {
          if (checkAuth) {
            return <AuthenticateUser user={userObj} history={props.history} />;
          }
          removeCookie("user");
          window.location.href = getRedirectUrlPostSignout();
        } else {
          /**
           * There may be following cases,
           * - Integration Settings Callback Redirect URL :
           *    If the current url's path name matches any of
           *    integration settings callback urls or,
           * - If user is logged-in and trying to change the url or
           *    trying to login with other user in same browser
           * If any of the above cases matches then,
           * redirect user to valid subdomain full url
           */
          window.location.href = getValidFullSubDomainUrl(subDomain);
        }
      } else {
        const { pathname, search } = window.location;
        if (pathname) {
          setCookie("fromUrl", `${pathname}${search}`);
        }
        window.location.href = getRedirectUrlPostSignout();
      }

      return null;
    }}
  />
);

export default PrivateRoute;



// WEBPACK FOOTER //
// ./src/app/PrivateRoute.js